import React from "react";
import "./What_Makes_Us_Different.css";
import What_Makes_Us_Different_card from "./What_Makes_Us_Different_card/What_Makes_Us_Different_card";

function What_Makes_Us_Different() {
  const cardData = [
    {
      headingText: "Live ETA Displays",
      descriptionText:
        "With dynamic digital screens and up-to-the-minute updates, passengers always know the exact arrival and departure times of their buses. No more guesswork or unnecessary waiting!",
    },
    {
      headingText: "Peace of Mind",
      descriptionText:
        "Passengers gain the assurance that their journey is well-planned. Knowing when their bus will arrive allows them to make better use of their time, whether it's grabbing a snack, attending to last-minute tasks, or simply relaxing.",
    },
    {
      headingText: "Enhanced Efficiency",
      descriptionText:
        "For operators, this system reduces congestion and ensures timely departures, creating a seamless experience for everyone involved.",
    },
    {
      headingText: "Trust and Transparency",
      descriptionText:
        "Real-time information builds trust among passengers, reinforcing their confidence in choosing public transport for their journeys.",
    },
  ];

  return (
    <>
      <section className="What_Makes_Us_Different">
        <div className="container">
          <div className="What_Makes_Us_Different_holder">
            <div className="heading-holder">
              <h1>What Makes Us Different?</h1>
            </div>
            <div className="What_Makes_Us_Different_card_holder">
              <div className="row">
                {cardData.map((card, index) => (
                  <div
                    key={index}
                    className="col-xl-6 col-lg-6  col-md-12  col-sm-12  card-holder"
                  >
                    <What_Makes_Us_Different_card
                      headingText={card.headingText}
                      descriptionText={card.descriptionText}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default What_Makes_Us_Different;
